import type { ManlyProfile } from "../profile";
import { assetUrl, PRODUCT_IMAGE } from "../assets";

export function ProductPage({ profile, onNext }: { profile: ManlyProfile; onNext: () => void }) {
  const connector =
    profile.primary.name === "Essential-oil fade-out"
      ? "Where essential oils fade, Kakadu Plum doesn't."
      : `Where ${profile.brandLabel} masks, Manly kills.`;

  return (
    <>
      <div className="qk-manly-kicker">The fix</div>
      <h2>Meet Manly. Made for teen chemistry.</h2>
      <p><strong>{connector}</strong></p>

      <p>
        <strong>The Natural Body Wash.</strong> One bottle, in the shower he already takes. A scent
        closer to something he'd actually choose than a teen spray.
      </p>

      <img
        className="qk-manly-hero"
        src={assetUrl(PRODUCT_IMAGE)}
        alt="Manly Natural Body Wash in Citrus Breeze, with its reported results: 94% total odor neutralization for up to 24 hours, 91% said their skin felt hydrated and smooth, 89% noticed a significant reduction in skin irritation and back-ne flare-ups"
        width={900}
        height={902}
        loading="lazy"
      />

      <div className="qk-manly-beats">
        <div className="qk-manly-beat">
          <span aria-hidden>{"\u{1F33F}"}</span>
          <div>
            <b>Kills, doesn't mask.</b> Wild-harvested Kakadu Plum kills odor-causing bacteria at the
            source. Nothing survives, nothing smells.
          </div>
        </div>
        <div className="qk-manly-beat">
          <span aria-hidden>{"\u{1F6E1}️"}</span>
          <div>
            <b>Hormone-safe by design.</b> Zero SLS, zero synthetic fragrance, zero parabens, zero
            phthalates.
          </div>
        </div>
        {/* The 90-participant / 72-hour clinical claim was retired with the kit:
            Manly attributes that study to the body wash AND deodorant together,
            so it can't carry a body-wash-only page. These are the numbers Manly
            publishes for the wash on its own, and they stay worded as reported
            (self-reported), matching the hero image above. */}
        <div className="qk-manly-beat">
          <span aria-hidden>{"\u{1F52C}"}</span>
          <div>
            <b>The results he'll notice.</b> 94% reported total odor neutralization for up to 24
            hours, and 89% saw less skin irritation and fewer back-ne flare-ups.
          </div>
        </div>
      </div>

      {/* Absolution only. Never claims a body wash causes or cures mood. */}
      {profile.mood && (
        <p className="qk-manly-note">
          You flagged the mood swings and low energy. That's puberty doing its job, not something a
          body wash causes or cures. But his system is running at maximum load, and that's exactly
          when you stop adding known disruptors on top.
        </p>
      )}

      <button type="button" className="qk-cta qk-manly-cta-sticky" onClick={onNext}>Claim my discount</button>
    </>
  );
}
